import apiService from "../../api/api.service";
import { HomeSectionResponse } from "./home.types";

/**
 * Tek section — kimlikli (axios `Authorization` + `X-Session-Id` gönderir).
 *
 * Key listesi (`GET /home/sections`) burada YOK: sayfanın hangi section'lardan
 * oluştuğunu sunucu tarafı belirliyor (getServerHomeSectionKeys, ISR'lı) ve
 * client bu iskeleti değiştiremiyor. Listeyi client'ta bir kez daha çekmek
 * yalnızca fazladan bir istekti.
 */
export const fetchHomeSection = async (
  slug: string,
): Promise<HomeSectionResponse> => {
  return apiService.get<HomeSectionResponse>(`/home/sections/${slug}`);
};
